import { c as _c } from "react/compiler-runtime";
import { cva } from "class-variance-authority";
import type { VariantProps } from "class-variance-authority";
import cn from "twsx";

// A 6px solid status mark beside a label (unread, live, failed). Decorative:
// pair it with text or an sr-only label that carries the meaning.
const statusDotVariants = cva("inline-block size-1.5 shrink-0 rounded-full", {
  variants: {
    tone: {
      accent: "bg-accent",
      neutral: "bg-text-quaternary",
      success: "bg-green-strong",
      warning: "bg-yellow-strong",
      danger: "bg-red-strong"
    }
  },
  defaultVariants: {
    tone: "accent"
  }
});
export type StatusDotProps = Omit<React.HTMLAttributes<HTMLSpanElement>, "children"> & VariantProps<typeof statusDotVariants>;

/** Use when a small dot beside a label marks unread, live or failed. */
export function StatusDot(t0) {
  const $ = _c(10);
  let className;
  let props;
  let tone;
  if ($[0] !== t0) {
    ({
      tone,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = tone;
  } else {
    className = $[1];
    props = $[2];
    tone = $[3];
  }
  let t1;
  if ($[4] !== className || $[5] !== tone) {
    t1 = cn(statusDotVariants({
      tone
    }), className);
    $[4] = className;
    $[5] = tone;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== props || $[8] !== t1) {
    t2 = <span aria-hidden="true" className={t1} {...props} />;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}